import React, { useState } from 'react';
import { cx } from './utils';

const AccordionItem = ({ item, isOpen, onToggle }) => (
  <div className="rounded-2xl border border-slate-200 bg-white">
    <button
      type="button"
      onClick={onToggle}
      className="flex w-full items-center justify-between gap-3 px-4 py-3 text-left text-sm font-semibold text-slate-800"
    >
      <span>{item.title}</span>
      <span className={cx('text-slate-400 transition', isOpen ? 'rotate-180' : '')}>v</span>
    </button>
    {isOpen && <div className="px-4 pb-4 text-sm text-slate-600">{item.content}</div>}
  </div>
);

const Accordion = ({ items = [], defaultIndex = 0, allowMultiple = false, className = '' }) => {
  const [openItems, setOpenItems] = useState(() => (allowMultiple ? [defaultIndex] : [defaultIndex]));

  const toggle = (index) => {
    if (allowMultiple) {
      setOpenItems((prev) =>
        prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
      );
    } else {
      setOpenItems((prev) => (prev[0] === index ? [] : [index]));
    }
  };

  return (
    <div className={cx('space-y-3', className)}>
      {items.map((item, index) => {
        const key = item.id || item.key || item.slug || item.title || `item-${index}`;
        return (
          <AccordionItem
            key={String(key)}
            item={item}
            isOpen={openItems.includes(index)}
            onToggle={() => toggle(index)}
          />
        );
      })}
    </div>
  );
};

export default Accordion;
